import React, { useState, useEffect } from 'react';
// import './ColumnSelectorModal.css';

const ColumnSelectorModal = ({ columns, selectedColumns, onClose, onConfirm }) => {
  const [localSelectedColumns, setLocalSelectedColumns] = useState([]);

  useEffect(() => {
    setLocalSelectedColumns(selectedColumns);
  }, [selectedColumns]);

  const toggleColumn = (column) => {
    if (localSelectedColumns.includes(column)) {
      setLocalSelectedColumns(localSelectedColumns.filter(col => col !== column));
    } else {
      setLocalSelectedColumns([...localSelectedColumns, column]);
    }
  };

  const handleConfirm = () => {
    onConfirm(localSelectedColumns);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content column-selector-modal">
        <div className="modal-header">
          <h3>Select Columns to Export</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {columns.map((column) => (
            <label key={column} className="column-checkbox">
              <input
                type="checkbox"
                checked={localSelectedColumns.includes(column)}
                onChange={() => toggleColumn(column)}
              />
              {column}
            </label>
          ))}
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleConfirm} disabled={localSelectedColumns.length === 0}>
            Export
          </button>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectorModal;
